import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TVATReportApi } from './types';

export const vatreport: TVATReportApi = {
	newVATReport: () => http.post(endpoint.vatReport.NEW_VAT_REPORT).then(response => response.data),
	vatReportStatus: payload =>
		http.get(endpoint.vatReport.VAT_REPORT_STATUS(payload.taskId)).then(response => response.data),
	vatReportFile: payload =>
		http
			.get(endpoint.vatReport.VAT_REPORT_FILE(payload.taskId), {
				responseType: 'blob',
			})
			.then(response => {
				return {
					filename: response.headers['x-filename'],
					file: response.data,
				};
			}),
	newVATReportWithPayment: () =>
		http.post(endpoint.vatReport.NEW_VAT_REPORT_WITH_PAYMENT).then(response => response.data),
	newNonUnionVATReport: () =>
		http.post(endpoint.vatReport.NON_UNION_VAT_REPORT).then(response => response.data),
	newNonUnionVATReportWithPayment: () =>
		http.post(endpoint.vatReport.NON_UNION_VAT_REPORT_WITH_PAYMENT).then(response => response.data),
	newNonUnionVATXmlReport: () =>
		http.post(endpoint.vatReport.NON_UNION_VAT_XML_REPORT).then(response => response.data),
	newNonUnionVATXmlReportWithPayment: () =>
		http
			.post(endpoint.vatReport.NON_UNION_VAT_XML_REPORT_WITH_PAYMENT)
			.then(response => response.data),
	newUnionVATReport: () =>
		http.post(endpoint.vatReport.UNION_VAT_REPORT).then(response => response.data),
	newUnionVATReportWithPayment: () =>
		http.post(endpoint.vatReport.UNION_VAT_REPORT_WITH_PAYMENT).then(response => response.data),
	getVatReports: () => http.get(endpoint.vatReport.GET_VAT_REPORTS).then(response => response.data),
	swissPostVATReport: () =>
		http.post(endpoint.vatReport.SWISS_POST_VAT_REPORT).then(response => response.data),
	euDdpVATReport: () =>
		http.post(endpoint.vatReport.EU_DDP_VAT_REPORT).then(response => response.data),
};
